import React from 'react';
import PropTypes from 'prop-types';
import { SizeGuideLabel as SizeGuideLabelStyled, SizeGuideLabelWrapper } from './SizeGuideLabel.css';
import { track } from '../../helpers';
import TrackingEvents from '../../common/models/TrackingEvents';
import Departments from '../../common/models/Departments';

const getSizeGuideName = (department, nonspecificLabel) => {
  const defaultSizeGuideName = 'Size Guide';
  if (nonspecificLabel) {
    return defaultSizeGuideName;
  }

  const {
    getMenInternalName,
    getWomenInternalName,
    getUnisexInternalName,
    getBabyKidsDepartmentsInternalNames,
    getJuniorKidsDepartmentsInternalNames,
  } = Departments;

  if (department === getMenInternalName()) {
    return `Men's ${defaultSizeGuideName}`;
  }
  if ([getWomenInternalName(), getUnisexInternalName()].includes(department)) {
    return `Women's ${defaultSizeGuideName}`;
  }
  if (
    getJuniorKidsDepartmentsInternalNames().includes(department) ||
    getBabyKidsDepartmentsInternalNames(department).includes(department)
  ) {
    return `Kids' ${defaultSizeGuideName}`;
  }
  return defaultSizeGuideName;
};

const SizeGuideLabel = ({ department, nonspecificLabel, setSizeGuideVisible }) => {
  return (
    <SizeGuideLabelWrapper>
      <SizeGuideLabelStyled
        data-cy="link-size-guide"
        onClick={() => {
          track(TrackingEvents.sizeGuideViewed(), {
            categoryDepartment: {
              department: department.toLowerCase(),
            },
          });
          if (setSizeGuideVisible) {
            setSizeGuideVisible();
          }
        }}
      >
        {getSizeGuideName(department, nonspecificLabel)}
      </SizeGuideLabelStyled>
    </SizeGuideLabelWrapper>
  );
};

SizeGuideLabel.propTypes = {
  nonspecificLabel: PropTypes.bool,
  setSizeGuideVisible: PropTypes.func.isRequired,
  department: PropTypes.string.isRequired,
};

export default SizeGuideLabel;
